module.exports = __webpack_public_path__ + "static/media/car1.58ded377.PNG";